module.exports = __webpack_public_path__ + "img/logo-ca.e6a16f43.png";